module.exports = __webpack_public_path__ + "img/t2x.50079191.png";